import React from "react";

export default function ContactSection1() {
  return (
    <section className="contact-section-22">
      <div className="container">
        <div className="contact-form-items">
          <div className="title text-center">
            <h2 className="wow fadeInUp">Dealers Applicant Form</h2>
          </div>
          <form action="https://api.web3forms.com/submit" method="POST">
            <div className="row g-4">
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".2s">
                <input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"/>
                <div className="form-clt">
                  <input
                    type="text"
                    name="name"
                    id="name"
                    placeholder="Full Name"
                  />
                  <div className="icon">
                    <i className="fa-regular fa-user" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                <div className="form-clt">
                {/* <input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"></input> */}
                  <input
                    type="text"
                    name="name"
                    id="name12"
                    placeholder="Company"
                  />
                  <div className="icon">
                    <i className="fa-regular fa-building" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".2s">
                <div className="form-clt">
                {/* <input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"></input> */}
                  <input
                    type="text"
                    name="number"
                    id="number"
                    placeholder="Phone Number"
                  />
                  <div className="icon">
                    <i className="fa-regular fa-phone" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                <div className="form-clt">
                {/* <input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"></input> */}
                  <input
                    type="text"
                    name="email"
                    id="email3"
                    placeholder="Email Address"
                  />
                  <div className="icon">
                    <i className="fa-regular fa-envelope" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".2s">
                <div className="form-clt">
                {/* <input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"></input> */}
                  <input
                    type="text"
                    name="state"
                    id="state"
                    placeholder="State"
                  />
                  <div className="icon">
                    <i className="fa-regular fa-map-marker" />
                  </div>
                </div>
              </div>
              <div className="col-lg-6 wow fadeInUp" data-wow-delay=".4s">
                <div className="form-clt">
                {/* <input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"></input> */}
                  <input
                    type="text"
                    name="city"
                    id="city"
                    placeholder="City"
                  />
                  <div className="icon">
                    <i className="fa-regular fa-city" />
                  </div>
                </div>
              </div>
              <div className="col-lg-12 wow fadeInUp" data-wow-delay=".2s">
                <div className="form-clt">
                {/* <input type="hidden" name="access_key" value="d8fd440b-b7b0-4931-8682-3c4eb67d846d"></input> */}
                  <textarea
                    name="message"
                    id="message"
                    placeholder="What’s on your mind"
                    defaultValue={""}
                  />
                  <div className="icon">
                    <i className="fa-sharp fa-light fa-pencil" />
                  </div>
                </div>
              </div>
              <input type="hidden" name="redirect" value="https://web3forms.com/success"></input>
              <div className="col-lg-12 wow fadeInUp" data-wow-delay=".4s">
                <button type="submit" className="theme-btn w-100">
                  SEND MESSAGE NOW
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
  );
}
